/**
 * Centralized auth for BB Docs frontend.
 *
 * The bb_ API key is provided via VITE_BB_API_KEY env var.
 * In production this comes from Cloudflare Pages environment variables.
 * In development, set it in frontend/.env.local:
 *   VITE_BB_API_KEY=bb_yourKeyHere
 */

const BB_API_KEY = import.meta.env.VITE_BB_API_KEY || '';

/**
 * Get the Authorization headers for API requests.
 * Returns empty object if no key is configured (public access).
 */
export function getAuthHeaders(): Record<string, string> {
  if (!BB_API_KEY) return {};
  return { Authorization: `Bearer ${BB_API_KEY}` };
}

/**
 * Get the full API key value (for X-API-Key header pattern).
 */
export function getApiKey(): string {
  return BB_API_KEY;
}

/**
 * Check if auth is configured.
 */
export function isAuthenticated(): boolean {
  return BB_API_KEY.length > 0;
}
